import gql from 'graphql-tag'

/*
------------------------------------------------------------------------------
Contributions
------------------------------------------------------------------------------
 */

export const ContactContributionFieldsFragment = gql`
    fragment ContactContributionFields on Contribution {
        id
        date
        amount
        user {
            first_name
            last_name
        }
        contributionSources {
            vendor
        }
        note {
            note
        }
    }
`

export const contactContributionsQuery = gql`
  ${ContactContributionFieldsFragment}
  query ($id: Int!) {
      contactContributions (id: $id) {
          ...ContactContributionFields
      }
  }
`

export const addContributionMutation = gql`
    ${ContactContributionFieldsFragment}
    mutation ($contactId: Int!, $amount: Float!, $date: String!, $note: String) {
        addContribution(contactId: $contactId, amount: $amount, date: $date, note: $note) {
            ...ContactContributionFields  
        }
    }
`

export const deleteContributionMutation = gql`
    mutation ($id: Int!) {
        deleteContribution(id: $id)
    }
`

/*
------------------------------------------------------------------------------
Contribution Asks
------------------------------------------------------------------------------
 */

export const ContributionAskFieldsFragment = gql`
    fragment ContributionAskFields on ContributionAsk {
        id
        date
        amount
        result
        user {
            first_name
            last_name
        }
        note {
            note
        }
    }
`

export const contactContributionAsksQuery = gql`
    ${ContributionAskFieldsFragment}
    query ($contactId: Int!) {
        contactContributionAsks (contactId: $contactId) {
            ...ContributionAskFields
        }
    }
`

export const addContributionAskMutation = gql`
    ${ContributionAskFieldsFragment}
    mutation ($contactId: Int!, $input: ContributionAskInput!, $note: String) {
        addContributionAsk(contactId: $contactId, input: $input, note: $note) {
            ...ContributionAskFields
        }
    }
`

export const deleteContributionAskMutation = gql`
    mutation ($id: Int!) {
        deleteContributionAsk(id: $id)
    }
`
